import styled from 'styled-components'

const Layer = styled.div`
  position: relative;
  margin: 10px;
  width: 250px;
  height: 250px;
  box-shadow: 2px 3px 6px grey;
`

export default Layer



// WEBPACK FOOTER //
// ./src/components/Layer.js